import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getEntries, deleteEntry, cleanupStatic } from '../../utils/api';

function AdminList() {
    const [tab, setTab] = useState('photo');
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');

    const load = () => {
        setLoading(true);
        setErr('');
        getEntries()
            .then(setEntries)
            .catch(e => setErr(e.message))
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const handleDelete = async (id, title) => {
        if (!window.confirm(`"${title}"을 삭제하시겠습니까?`)) return;
        try {
            await deleteEntry(id);
            load();
        } catch (e) {
            alert(e.message);
        }
    };

    const handleCleanup = async () => {
        if (!window.confirm('서버에 남아있는 오래된 빌드 파일을 정리하시겠습니까?')) return;
        try {
            const result = await cleanupStatic();
            const freedMB = (result.freedBytes / 1024 / 1024).toFixed(2);
            alert(`${result.message} (${freedMB}MB 확보)`);
        } catch (e) {
            alert(e.message);
        }
    };

    const filtered = entries
        .filter(e => e.category === tab)
        .sort((a, b) => parseInt(b.year) - parseInt(a.year));

    return (
        <div className="admin-content">
            <div className="admin-list-header">
                <div className="admin-tabs">
                    <button className={tab === 'photo' ? 'active' : ''} onClick={() => setTab('photo')}>Photo</button>
                    <button className={tab === 'art' ? 'active' : ''} onClick={() => setTab('art')}>Art</button>
                </div>
                <div className="admin-list-actions">
                    <a href={`/test/${tab}`} target="_blank" rel="noreferrer" className="admin-btn-preview">미리보기</a>
                    <button className="admin-btn-preview" onClick={handleCleanup}>서버 정리</button>
                    <Link to="/admin/new" className="admin-btn-add">+ 새 항목 추가</Link>
                </div>
            </div>

            {err && <div className="admin-error">{err}</div>}

            <table className="admin-table">
                <thead>
                    <tr>
                        <th style={{ width: 80 }}>년도</th>
                        <th>제목</th>
                        <th style={{ width: 80 }}>블록 수</th>
                        <th style={{ width: 140 }}>작업</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td colSpan="4" className="admin-empty">불러오는 중...</td></tr>
                    ) : filtered.length === 0 ? (
                        <tr><td colSpan="4" className="admin-empty">등록된 항목이 없습니다.</td></tr>
                    ) : filtered.map(entry => (
                        <tr key={entry.id}>
                            <td>{entry.year}</td>
                            <td>{entry.title}</td>
                            <td>{entry.blocks?.length || 0}</td>
                            <td>
                                <Link to={`/admin/edit/${entry.id}`} className="admin-btn-edit">수정</Link>
                                <button className="admin-btn-delete" onClick={() => handleDelete(entry.id, entry.title)}>삭제</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AdminList;
